import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { ServicesSubSectionHeader } from '../../services/services-subsection/services-subsection.styles';
import {
  PriceValue,
  PriceTitle,
  GridContainer,
} from '../../../routes/parcel-content/parcel-content.styles';
import TaxesSidebar from './taxes-sidebar.component';
import { useStore } from '../../../stores/store';
import { getFormattedPrice } from '../../../utils/price/get-formatted-price';
import { TaxesSectionContainer } from './parcel-taxes-info.styles';
import { Shipment } from '../../../models/parcelDeliveryMiles';
import TaxesInfoItaly from './country-specific/taxes-info.italy.component';
import { isFeatureRequired } from '../../../utils/client/client.utils';

interface Props {
  shipment?: Shipment;
  hideRules?: boolean;
}

const ParcelTaxesInfo = ({ shipment, hideRules }: Props) => {
  const {
    userStore: { getCurrencySymbol },
    parcelCreationStore: { navigation },
  } = useStore();
  const { t } = useTranslation();

  const isParcelContentStep = navigation.current?.name === 'parcel-content';

  if (shipment?.sender?.country === 'IT')
    return <TaxesInfoItaly stepInfo={navigation.current} />;

  const showTaxesSidebar =
    isParcelContentStep &&
    navigation.current?.elements.find((el) => el.name === 'taxes') &&
    !hideRules;

  const isDomestic = shipment?.sender?.country === shipment?.recipient?.country;

  if (!shipment) return;

  const getHeaderTransKey = () =>
    isDomestic &&
    isFeatureRequired('useGstHstInsteadOfTaxes', shipment?.sender?.country)
      ? 'GST_HST'
      : 'taxes';

  return (
    <TaxesSectionContainer>
      <ServicesSubSectionHeader>
        {t(getHeaderTransKey())}
      </ServicesSubSectionHeader>
      <GridContainer>
        {shipment.taxes > 0 && (
          <>
            <PriceTitle>
              {t('create_parcel_summary_taxes_paid_by_sender')}
            </PriceTitle>
            <PriceValue>
              {getFormattedPrice(
                shipment.taxes,
                getCurrencySymbol(shipment?.converted_price?.currency)
              )}
            </PriceValue>
          </>
        )}
        {!isDomestic && (
          <>
            <PriceTitle>
              {t('create_parcel_summary_taxes_paid_by_receiver')}
            </PriceTitle>

            <PriceValue>
              {t('create_parcel_summary_taxes_paid_by_receiver_text')}
            </PriceValue>
          </>
        )}
      </GridContainer>
      {showTaxesSidebar && <TaxesSidebar />}
    </TaxesSectionContainer>
  );
};

export default observer(ParcelTaxesInfo);
